import "./MachineInfoStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { StackPanelComponent } from "jsl-ui";
import { mapUrl } from "../../helper/mapUrl";
import { ContactBoxComponent } from "./ContactBoxComponent";
import { LandingPageInfoModel } from "../../ajax/types/LandingPageInfoModel";

export class MachineInfoComponent implements IJSLComponent {

    // private partedMatchcode: string;

    public constructor(private objektInfo: LandingPageInfoModel) {
        // this.partedMatchcode = objektInfo.Objekt.ArtMatchcode?.replace("Vollautomat", "") + "(PNG)";
        // console.log(this.objektInfo.Objekt?.Artikelnummer);
        // console.log(mapUrl("Ajax/GetNewDownloadImage?artikelnummer=" + this.objektInfo.Objekt?.Artikelnummer));
    }

    public render(): IJSLVNode {
        return (
            <div class="info-box" id="machine-info" style="text-align:center;">
                <div style="text-align:left">
                    <div class="norm-info">Ihr Gerät mit der Seriennummer: {this.objektInfo.Objekt?.Seriennummer}</div>
                    <div class="norm-info">Ihre Service-ID: {this.objektInfo.ProjektePositionen?.ProjektPosID}</div>
                    <div class="norm-info">Ihr Modell: {this.objektInfo.Objekt?.ArtMatchcode}</div>
                </div>
                {
                    new StackPanelComponent([
                        <div>
                            <img src={mapUrl("Ajax/GetNewDownloadImage?artikelnummer=" + this.objektInfo.Objekt?.Artikelnummer)} style="max-width:95%;max-height:18rem;" />
                        </div>,
                        new ContactBoxComponent()],
                        {
                            sizes: ["40%", "60%"],
                            responsive: true,
                            valign: "center"
                        })
                }
                {this.objektInfo.VerpackungsBild ?
                    <div>
                        <img style="height:9rem" src={this.objektInfo.VerpackungsBild} alt="Verpackungsinformation" />
                    </div> :
                    undefined}

                {this.objektInfo.VerpackungsLink ?
                    <div><a href={this.objektInfo.VerpackungsLink} target="_blank">Youtube Video</a></div> :
                    undefined}
            </div>
        );
    }
}
